<template>
  <div id="navs" class="font no-print">
    <header class="py-3 nav-dd" role="banner" aria-label="網站標頭">
      <!-- 左-圖片超連 -->
      <div class="col-4 ml-2">
        <a href="https://www.nuk.edu.tw/" title="回高雄大學首頁">
          <img
            class="nav-img float-left"
            src="../../assets/logoword_2.png"
            alt="回高大"
          />
        </a>
      </div>
      <!-- 中-標題 -->
      <div class="col-4 ml-2 mr-3">
        <a
          class="nav-size word-bold"
          href="#/index/news"
          style="line-height: 12px;text-decoration: none;"
        >
          <v-font v-if="Testsystem === true" font-text="測試環境-" />
          <v-font font-css="nav-sizes" font-text="多元繳費系統" />
          <br />
          <v-font
            id="enav"
            font-css="nav-fsize nav-fss"
            font-text="Multi Payment System"
          />
        </a>
      </div>
      <!-- 右-登入狀態-帳號資訊 -->
      <div class="col-3 text-right">
        <div v-if="UserData === false">
          <v-font font-css="nav-font-size" font-text="未登入" />
        </div>
        <div v-else>
          <span class="nukWord nav-fs">
            {{ UserData.UserName }}
            <span class="nav-fss">({{ UserData.UserId }})</span>
          </span>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 確認帳號資訊
      Testsystem: window.g.Testsystem,
      UserData: JSON.parse(localStorage.getItem('M_UserData'))
        ? JSON.parse(localStorage.getItem('M_UserData'))
        : false
    }
  },
  created () {
    // 接收登入資訊
    this.$bus.$on('LoginUser', data => {
      this.LoginUser(data)
    })
    // 接收登出資訊
    this.$bus.$on('LogOutUser', () => {
      this.LogOutUsers()
    })
  },
  methods: {
    LoginUser (data) {
      // 判斷登入變換資訊
      this.UserData = JSON.parse(localStorage.getItem('M_UserData'))
    },
    LogOutUsers () {
      this.UserData = false
    }
  }
}
</script>
